export =[
    {
        "circle": {
            "fill": {
                "color": "rgba(197,37,84,0.90)"
            },
            "opacity": 1,
            "stroke": {
                "color": "rgba(227,83,105,1)",
                "width": 4.4
            },
            "radius": 7.3
        },
        "text": {
            "fill": {
                "color": "rgba(205,86,109,0.9)"
            },
            "stroke": {
                "color": "rgba(252,175,131,0.5)",
                "width": 2
            },
            "text": "Test",
            "offset-x": 0,
            "offset-y": 20,
            "font": "18px fantasy"
        }
    }
];